import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  Output,
  ViewChild,
  OnDestroy
} from '@angular/core';
import {
  TabulatorService,
  TransformationService,
  TimeoutWrapper,
  DialogService
} from '@nrwl/common-lib';
import { Subscription } from 'rxjs';
import { Options } from 'tabulator-tables';
import { ViaviTableComponent } from '@nrwl/viavi-tabulator';
import { cloneDeep } from 'lodash';
@Component({
  selector: 'nrwl-cart-picker-table',
  templateUrl: './cart-picker-table.component.html',
  styleUrls: ['./cart-picker-table.component.scss'],
  providers: [TimeoutWrapper]
})
export class CartPickerTableComponent implements OnInit, OnDestroy {
  @ViewChild(ViaviTableComponent) deviceTable: ViaviTableComponent;
  @Input() cartItems;
  @Input() singleSelection;
  @Input() persistenceID;
  @Input() tableData;
  @Input() cartView;
  @Input() transformationString;
  @Input() selectionLimit;
  @Input() childRows;
  //eslint-disable-next-line
  @Output() updateCartItems?: EventEmitter<any> = new EventEmitter();
  show: boolean;
  table: Options;
  timeout: TimeoutWrapper;
  options;
  private cartItemsSubscription: Subscription;
  constructor(
    private tabulatorService: TabulatorService,
    private transformationService: TransformationService,
    timeout: TimeoutWrapper,
    private dialogService: DialogService
  ) {
    this.timeout = timeout;
    this.show = false;
    this.table = null;
    this.table = this.tabulatorService.commonTableConfiguration();
    this.table.persistenceID = this.persistenceID;
    this.table.groupHeader = this.tabulatorService.groupHeader;
    this.table.initialSort = [{ column: 'name', dir: 'desc' }];
  }

  ngOnInit(): void {
    this.cartItemsSubscription = this.tabulatorService?.addToCartClicked?.subscribe(cartItems => {
      this.onClickAddtoCart(cartItems);
    });
    this.options = {
      selectionLimit: this.selectionLimit,
      cartLength: this.cartItems?.length ?? 0
    };
    this.table.initialSort = [
      {
        column: 'name.label',
        dir: 'asc'
      }
    ];
    this.tableData?.subscribe(res => {
      this.createTable(res);
    });
  }
  //eslint-disable-next-line
  createTable(res): void {
    const lists = cloneDeep(res);
    const tableData = this.transformationService.transformData(this.transformationString, lists);
    this.table.height = 500;
    if (this.childRows) {
      this.table.dataTree = true;
      this.table.headerSort = true;
      this.table.movableColumns = true;
      this.table.dataTreeStartExpanded = false;
      this.table.dataTreeSelectPropagate = false;
    }
    this.table.paginationSize = 100;
    this.table.paginationSizeSelector = [100, 200, 500];
    delete this.table.rowHeight;
    if (this.singleSelection) {
      delete this.table.selectable;
      delete this.table.selectableRangeMode;
    }
    this.table.columns = tableData.column;
    this.table.data = tableData.data;
    if (this.table.persistence) {
      this.table.persistence.sort = true;
      this.table.persistence.page = true;
    }
    if (this.singleSelection) {
      this.table.hideSelectAll = true;
    }
    if (this.cartView && this.cartItems && this.cartItems.length > 0) {
      this.cartItems.forEach(item => {
        const index = this.table.data.findIndex(i => i.id === item.id);
        if (index !== -1) {
          this.table.data.splice(index, 1);
        }
      });
      this.table = Object.assign({}, this.table);
    } else {
      this.table = Object.assign({}, this.table);
    }
    this.timeout.add(() => {
      this.show = true;
    }, 300);
  }
  //eslint-disable-next-line
  sendSelectedItem(event: { type: string }): void {
    if (this.singleSelection) {
      const oldRowSelection = Object.assign([], this.deviceTable.table.getSelectedData());
      if (oldRowSelection.length > 1) {
        const x = oldRowSelection[0];
        this.deviceTable.table.deselectRow(x.id);
      }
    }
    if (
      event.type === 'single' &&
      this.cartItems.length + this.deviceTable?.selection?.length > this.selectionLimit
    ) {
      const oldRowSelection = Object.assign([], this.deviceTable.table.getSelectedData());
      const x = oldRowSelection.pop();
      this.deviceTable.table.deselectRow(x.id);
      this.showBulkTestLimitDialog();
    }
  }

  //eslint-disable-next-line
  onClickAddtoCart(items) {
    items = this.removeParent(items);
    this.cartItems = [...this.cartItems, ...items];
    this.options = {
      selectionLimit: this.selectionLimit,
      cartLength: this.cartItems.length
    };
    this.updateCartItems.emit(this.cartItems);
    this.updateTable(items);
  }
  //eslint-disable-next-line
  updateTable(items): void {
    items.forEach(item => {
      const index = this.table.data.findIndex(i => i.id === item.id);
      if (index !== -1) {
        this.table.data.splice(index, 1);
      }
    });
    this.table = Object.assign({}, this.table);
    this.deviceTable.table.deselectRow();
  }
  //eslint-disable-next-line
  removeParent(items: any): any {
    return items.map(item => {
      item.removed = false;
      item.notAvailed = false;
      if (item.rowType === 'parent') {
        return item._children[0];
      } else {
        return item;
      }
    });
  }

  showBulkTestLimitDialog(): void {
    const params = { action: 'bulk.selection' };
    const param = {
      id: params.action,
      alternateMsg: `You can only select ${this.options.selectionLimit} endpoints. Please reduce your amount and try again.`,
      alternateTitle: 'Endpoint limit exceeded',
      callBackService: this
    };
    this.dialogService.showDialog('confirm', 'body', param);
  }
  ngOnDestroy() {
    if (this.cartItemsSubscription) {
      this.cartItemsSubscription.unsubscribe();
    }
  }
}
